import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 30, 30, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  max-width: 900px;
  width: 90%;
  max-height: calc(100vh - 32px); /* browsers without dvh (older iPads, Chromebooks) */
  max-height: calc(100dvh - 32px);
  height: auto;
  min-height: 0;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
  display: flex;
  overflow-y: auto;
  @media (max-width: 800px) { width: calc(100vw - 24px); }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-family: var(--font-family-ibm_plex_sans);
  z-index: 10;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const LeftSection = styled.div`
  flex: 1;
  padding: 52px 32px 32px;
  min-width: 0;
  @media (max-width: 800px) { padding: 52px 20px 24px; }
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: white;
  overflow: visible;
`;

export const RightSection = styled.div`
  @media (max-width: 800px) { display: none; }
  width: 380px;
  flex-shrink: 0;
  background: #F3E8FF;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PurpleBanner = styled.div`
  background: #7200E0;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: var(--font-family-ibm_plex_sans);
  align-self: flex-start;
  margin-bottom: 24px;
`;

export const MainTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0 0 40px 0;
  line-height: 1.5;
`;

export const EmailSection = styled.div`
  margin-bottom: 40px;
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 20px 0;
  }
  
  &::before,
  &::after {
    content: none;
    display: none;
  }
`;

export const EmailInput = styled.input`
  width: 100%;
  padding: 12px 30px 12px 16px;
  border: 2px solid ${props => props.hasError ? '#ff4444' : '#e0e0e0'};
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 4px;
  font-family: var(--font-family-ibm_plex_sans);
  transition: border-color 0.2s;
  display: block;
  
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#ff4444' : '#7200E0'};
  }
  
  &::placeholder {
    color: #999;
  }
  
  &::before,
  &::after {
    content: none;
    display: none;
  }
`;

export const ErrorText = styled.div`
  color: #E2483D;
  font-size: 12px;
  margin-bottom: 8px;
  margin-top: 4px;
  font-family: var(--font-family-ibm_plex_sans);
  white-space: normal;
  word-break: normal;
  display: block;
  width: 100%;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.4;
  
  &::before,
  &::after {
    content: none !important;
  }
`;

export const EmailFieldContainer = styled.div`
  margin-bottom: 8px;
  position: relative;
  
  label {
    display: none !important;
  }
  
  &::before,
  &::after {
    content: none !important;
    display: none !important;
  }
  
  * {
    &::before,
    &::after {
      content: none !important;
    }
  }
`;

export const RemoveEmailButton = styled.button`
  position: absolute;
  top: 14px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  height: 10px;
  opacity: 0.6;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 1;
  }
  
  img {
    width: 10px;
    height: 10px;
  }
`;

export const AddEmailLink = styled.button`
  background: none;
  border: none;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-bottom: 20px;
  text-decoration: none;
  
  &:hover {
    color: #666;
  }
`;

export const SendInvitesButton = styled.button`
  background: #7200E0;
  color: white;
  border: none;
  padding: 12px 12px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans);xs
  transition: background-color 0.2s;
  
  &:hover:not(:disabled) {
    background: #5A00B8;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SkipLink = styled.button`
  background: none;
  border: none;
  color: #7200E0;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  margin-top: auto;
  align-self: center;
  
  &:hover {
    color: #5A00B8;
  }
`;

export const ClassroomIllustration = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeatureBubbles = styled.div`
  position: absolute;
  top: 15%;
  left: 15%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FeatureBubble = styled.div`
  background: white;
  color: #1a1a1a;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const IllustrationImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;
`;

export const ErrorTextWithMargin = styled(ErrorText)`
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
